import { z } from 'zod';

export const AreaGroupSchema = z.object({
  id: z.string().uuid(),
  project_id: z.string().uuid(),
  name: z.string(),
  sort_order: z.number().int().default(0),
  phase_id: z.string().uuid().nullable(),
  created_by: z.string().uuid().nullable(),
});

export const CreateAreaGroupSchema = z.object({
  project_id: z.string().uuid(),
  name: z.string().min(1, 'Group name is required'),
  sort_order: z.number().int().default(0),
  phase_id: z.string().uuid().nullable().optional(),
});

export const UpdateAreaGroupSchema = CreateAreaGroupSchema.partial();

export type AreaGroup = z.infer<typeof AreaGroupSchema>;
export type CreateAreaGroup = z.infer<typeof CreateAreaGroupSchema>;
export type UpdateAreaGroup = z.infer<typeof UpdateAreaGroupSchema>;
